import { useState, useCallback } from 'react';

interface LoadingState {
  [key: string]: boolean;
}

export const useSpinner = () => {
  const [loadingStates, setLoadingStates] = useState<LoadingState>({});
  const mostrarLoading = useCallback((selector: string) => {
    setLoadingStates((prev) => ({
      ...prev,
      [selector]: true,
    }));
  }, []);
  const quitarLoading = useCallback((selector: string) => {
    setLoadingStates((prev) => ({
      ...prev,
      [selector]: false,
    }));
  }, []);
  const quitarTodosLoading = useCallback(() => {
    setLoadingStates({});
  }, []);
  const hayLoadingActivo = Object.values(loadingStates).some(Boolean);

  const isLoading = useCallback(
    (selector: string): boolean => {
      return loadingStates[selector] || false;
    },
    [loadingStates],
  );

  return {
    loading: loadingStates,
    mostrarLoading,
    quitarLoading,
    quitarTodosLoading,
    hayLoadingActivo,
    isLoading,
  };
};

export const useSimpleSpinner = (initialState = false) => {
  const [loading, setLoading] = useState(initialState);

  const startLoading = useCallback(() => {
    setLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
  }, []);

  const toggleLoading = useCallback(() => {
    setLoading((prev) => !prev);
  }, []);

  return {
    loading,
    startLoading,
    stopLoading,
    toggleLoading,
    setLoading,
  };
};

export default useSpinner;
